// @index('./*/index.tsx', f => `export * from '${f.path.replace("/index", "")}';`)
export * from './FeatureList';
export * from './FeaturesSection';
export * from './FreeSection';
export * from './HeroSection';
export * from './QuestionsSection';
export * from './RewardsSection';
export * from './SeriousSection';
export * from './StepCard';
export * from './StepsSection';
